import React from 'react';
import logo1 from '../../../assets/images/brand-logos/logo_1.png';

const DocumentHeader: React.FC = () => {
  // Static header data
  const headerData = {
    type: 'Survey',
    department: 'OPS',
    scope: 'External',
    issue_date: new Date('2025-09-10'),
    document_ref_no: 'TT-OPS-FRM-004',
    title: 'Survey Calculation Report',
    sub_title: 'Surveys',
    rev: 'A',
    rev_date: new Date('10-sep-2025'),
  };

  const currentPageNo = 1;
  const totalPageNo = 1;

  // Helper functions
  const titleCase = (str: string) =>
    str.replace(/\w\S*/g, (txt) => txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase());

 const formatDate = (date: Date) => {
  const options: Intl.DateTimeFormatOptions = { day: '2-digit', month: 'short', year: 'numeric' };
  const formatted = date.toLocaleDateString('en-GB', options); // e.g., "10 Sep 2025"
  // Replace space with dash and ensure month is capitalized first letter
  return formatted.replace(/ /g, '-').replace(/-([a-zA-Z]{3})-/g, (match, p1) => `-${p1.charAt(0).toUpperCase()}${p1.slice(1)}-`);
};

  return (
    <div className="pdfwidth !w-full !bg-white">
      <div className="pdfcontent">
        <div className="w-full">
          <table className="table-auto border-collapse !w-full">
            <tbody>
              <tr className="h-[27.05pt] align-baseline">
                <td className="w-[41.95pt] border border-white px-[5.03pt] text-center align-middle bg-[#808080]">
                  <p className="m-0 text-white text-[10pt]">Type</p>
                </td>
                <td className="w-[56.85pt] border border-white px-[5.03pt] text-center align-middle bg-[#808080]">
                  <p className="m-0 text-white text-[10pt]">Department</p>
                </td>
                <td className="w-[33.55pt] border border-white px-[5.03pt] text-center align-middle bg-[#808080]">
                  <p className="m-0 text-white text-[10pt]">Scope</p>
                </td>
                <td className="w-[56.8pt] border border-white px-[5.03pt] text-center align-middle bg-[#808080]">
                  <p className="m-0 text-white text-[10pt]">Issue Date</p>
                </td>
                <td className="w-[152.95pt] border border-white px-[5.03pt] text-center align-middle bg-[#808080]">
                  <p className="m-0 text-white text-[10pt]">Document Ref #</p>
                </td>
                <td 
                  colSpan={3} 
                  rowSpan={2}
                  className="w-[133.9pt] border border-white px-[5.03pt] text-center align-middle bg-gray-200"
                >
                  <img
                    src={logo1}
                    width="179" 
                    height="64" 
                    alt="Logo"
                  />
                </td>
              </tr>
              <tr className="h-[22.8pt] align-baseline">
                <td className="w-[41.95pt] border border-white px-[5.03pt] text-center align-middle bg-gray-200">
                  <p className="m-0 text-black text-[8pt]">{titleCase(headerData.type)}</p>
                </td>
                <td className="w-[56.85pt] border border-white px-[5.03pt] text-center align-middle bg-gray-200">
                  <p className="m-0 text-black text-[8pt]">{headerData.department}</p>
                </td>
                <td className="w-[33.55pt] border border-white px-[5.03pt] text-center align-middle bg-gray-200">
                  <p className="m-0 text-black text-[8pt]">{titleCase(headerData.scope)}</p>
                </td>
                <td className="w-[56.8pt] border border-white px-[5.03pt] text-center align-middle bg-gray-200">
                  <p className="m-0 text-black text-[8pt]">{formatDate(headerData.issue_date)}</p>
                </td>
                <td className="w-[152.95pt] border border-white px-[5.03pt] text-center align-middle bg-gray-200">
                  <p className="m-0 text-black text-[8pt]">{headerData.document_ref_no}</p>
                </td>
              </tr>
              <tr className="h-[18.6pt]">
                <td className="w-[41.95pt] border border-white px-[5.03pt] text-center align-middle bg-gray-200">
                  <p className="m-0 text-black text-[10pt]">Title</p>
                </td>
                <td colSpan={4} className="border border-white px-[5.03pt] text-center align-middle bg-gray-200">
                  <p className="m-0 text-black text-[10pt]">{titleCase(headerData.title)}</p>
                </td>
                <td className="w-[33.65pt] border border-white px-[5.03pt] text-center align-middle bg-[#808080]">
                  <p className="m-0 text-white text-[10pt]">Pages</p>
                </td>
                <td className="w-[20.45pt] border border-white px-[5.03pt] text-center align-middle bg-[#808080]">
                  <p className="m-0 text-white text-[10pt]">Rev.</p>
                </td>
                <td className="w-[58.2pt] border border-white px-[5.03pt] text-center align-middle bg-[#808080]">
                  <p className="m-0 text-white text-[10pt]">Rev. Date</p>
                </td>
              </tr>
              <tr className="h-[18.6pt]">
              <td className="border border-white px-[5.03pt] text-center align-middle bg-gray-200 whitespace-nowrap">
  <p className="m-0 text-black text-[10pt]">Sub Title</p>
</td>

                <td colSpan={4} className="border border-white px-[5.03pt] text-center align-middle bg-gray-200">
                  <p className="m-0 text-black text-[10pt] font-bold">{titleCase(headerData.sub_title)}</p>
                </td>
                <td className="w-[33.65pt] border border-white px-[5.03pt] text-center align-middle bg-gray-200">
                  <p className="m-0 text-black text-[8pt]">{currentPageNo} of {totalPageNo}</p>
                </td>
                <td className="w-[20.45pt] border border-white px-[5.03pt] text-center align-middle bg-gray-200">
                  <p className="m-0 text-black text-[8pt]">{headerData.rev}</p>
                </td>
                <td className="w-[58.2pt] border border-white px-[5.03pt] text-center align-middle bg-gray-200">
                  <p className="m-0 text-black text-[8pt]">{formatDate(headerData.rev_date)}</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default DocumentHeader;
